"use client";

import { useEffect } from "react";
import { MOOV_WHATSAPP_URL } from "@/components/sections/lp-moov/content";

const REDIRECT_DELAY_MS = 3000;

export default function WhatsAppRedirect() {
    useEffect(() => {
        const timer = window.setTimeout(() => {
            window.location.assign(MOOV_WHATSAPP_URL);
        }, REDIRECT_DELAY_MS);
        return () => window.clearTimeout(timer);
    }, []);

    return null;
}
